export const updateQueryParams = (key, value)=>{
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, encodeURIComponent(value));
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
    return newRelativePathQuery;
};
export const isActivePath = (path)=>path == window.location.pathname;
export function scrollToTop() {
    window.scrollTo(0, 0);
}
const smallViewPortThreshold = 1024;
export const isSmallViewport = ()=>window.innerWidth < smallViewPortThreshold;
/** Gets the main domain (e.g. example.com) from the full hostname (e.g. sub.example.com) */ export const getMainDomain = ()=>{
    const hostnameParts = window.location.hostname.split('.');
    if (hostnameParts.length <= 2) {
        return window.location.hostname // already main domain
        ;
    }
    return hostnameParts.slice(-2).join('.') // get last two parts
    ;
};
/**
 * Returns the current window's protocol and host as a string.
 *
 * @returns {string} The protocol (e.g., 'http:' or 'https:') followed by '//' and the host (e.g., 'example.com:3000').
 *
 * @example
 * // If the current URL is 'https://example.com:3000/page'
 * protocolAndHost(); // returns 'https://example.com:3000'
 */ export const protocolAndHost = ()=>window.location.protocol + '//' + window.location.host;
